import { configureStore } from "@reduxjs/toolkit";
//
import commonReducer from "./commonSlice";
import userReducer from "./userSlice";
import settingReducer from "./settingSlice";
import authSlice from "./authSlice";

export default configureStore({
  reducer: {
    common: commonReducer,
    user: userReducer,
    setting: settingReducer,
    auth: authSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // 忽略 non-serialization 的 value:例如 function
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ["common/setCommonDialogContext"],
        // Ignore these field paths in all actions
        ignoredActionPaths: [],
        // Ignore these paths in the state
        ignoredPaths: ["common.dialogContext.onYes"],
      },
    }),
});
